/* eslint-disable indent */
export default {
  methods: {
    answerSave: function(section, step, id, value, point, ans) {
      let res = {
        'section': section,
        'answer': {
          'step': step,
          'id': id,
          'value': value,
          'point': point,
          'ans': ans
        }
      }
      this.$store.dispatch('answers/saveAnswer', res)
    }
  }
}
